import React, { useState } from 'react'
import Title from '../../components/Title/Title';
import { Col, Container, Row } from 'react-bootstrap';
import EventCard from '../../components/EventCard';
import Button from '../../components/Button';
import SectionHeader from '../../components/SectionHeader';
import './PrivacyPolicy.scss'

function PrivacyPolicy(props) {



    return (
        <>

            <div className="usp">

            </div>
            <div className="container-fluid2 bg2 ">
                <Title options={{ "title": "Privacy Policy | EFH Education From Home", "description": "Read the EFH (Education From Home) privacy policy to learn how we collect, use, and protect the personal information of our students and visitors.", "image": "", "url": "" }} />

                <div className="container sectionheader ">


                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='card p-3'>
                                <h2 className="text-center fw-bold mb-4" style={{ fontSize: "250%", lineHeight: "2" }}>Our <span className="text-primary">Privacy Policy</span></h2>
                                <ol className="" style={{ fontSize: "130%", lineHeight: "2" }}>
                                    <li className="mb-3">
                                        <span className="fw-bold text-primary">Information Collection:</span> We collect personal information such as name, email, and phone number when you register on our website or use our services.
                                    </li>
                                    <li className="mb-3">
                                        <span className="fw-bold text-primary">Usage Data:</span> We may collect information about your interactions with our website, including IP address, browser type, and pages visited.
                                    </li>
                                    <li className="mb-3">
                                        <span className="fw-bold text-primary">Information Use:</span> We use your information to provide services, communicate with you, and improve user experience.
                                    </li>
                                    <li className="mb-3">
                                        <span className="fw-bold text-primary">Information Sharing:</span> We may share your information with third-party service providers and for legal compliance.
                                    </li>
                                    <li className="mb-3">
                                        <span className="fw-bold text-primary">Data Security:</span> We implement security measures to protect your information, but we cannot guarantee absolute security.
                                    </li>
                                    <li className="mb-3">
                                        <span className="fw-bold text-primary">Your Rights:</span> You have the right to access, update, and delete your information. You can also opt out of communications.
                                    </li>
                                    <li className="mb-3">
                                        <span className="fw-bold text-primary">Children's Privacy:</span> Our services are not directed to children under 13, and we do not knowingly collect personal information from them.
                                    </li>
                                    <li>
                                        <span className="fw-bold text-primary">Changes to Policy:</span> We may update this policy periodically and will notify you of any material changes.
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};


export default PrivacyPolicy;
